/**
 * DevExtreme (ui/number_box/number_box.js)
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var registerComponent = require("../../core/component_registrator");
var NumberBoxMask = require("./number_box.mask");
registerComponent("dxNumberBox", NumberBoxMask);
module.exports = NumberBoxMask;



//////////////////
// WEBPACK FOOTER
// ./~/devextreme/ui/number_box/number_box.js
// module id = 1193
// module chunks = 0